import { useReducer } from 'react';

interface IUseCrossTabStateAction<T> {
  type: string;
  value: T;
}

function reducer<T>(state: T, action: IUseCrossTabStateAction<T>) {
  switch (action.type) {
    case 'set':
      state = action.value;
      return state;
    default:
      throw new Error();
  }
}

export default function useCrossTabState<T>(
  name: string,
  initialState: T
): [T, (value: T) => void] {
  const [state, dispatch] = useReducer(reducer, initialState);
  const channel = new BroadcastChannel(name);

  channel.onmessage = (event: MessageEvent) => {
    event.preventDefault();
    const { data: value } = event;
    dispatch({ type: 'set', value });
  };

  const setState = (value: T) => {
    channel.postMessage(value);
    dispatch({ type: 'set', value });
  };

  return [state as T, setState];
}
